export default {"src":"/_next/static/media/SDG_Impact_Fund.091982b3.svg","height":208,"width":180,"blurWidth":0,"blurHeight":0};